import React from 'react';
import '../../styles/ApiFields.scss';
import { CONSTANTS } from '../../constants';
import { ManageApiFieldsTable } from './ManageApiFieldsTable';

export const ManageApiFields = ({ apiDetails }) => {
  const { id, apiDisplayName } = apiDetails;
  return (
    <div
      data-testid="step-manage-api-fields"
      className="manage-api-fields__container"
    >
      <p
        data-testid="manage-api-fields-description"
        className="manage-api-fields__description"
      >
        {CONSTANTS.MANAGE_API_FIELDS_DESCRIPTION}
      </p>
      <ManageApiFieldsTable apiName={apiDisplayName} apiId={id} />
    </div>
  );
};
